"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _util = require("../../../util");
require("./_styles.scss");
var _base = _interopRequireDefault(require("../texts/base"));
var _questionIcon = _interopRequireDefault(require("../../../assets/question-icon.svg"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var BLOCK_CLASS = 'pf-tooltip';
var Tooltip = function Tooltip(_ref) {
  var className = _ref.className,
    title = _ref.title;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    showTooltip = _useState2[0],
    setShowTooltip = _useState2[1];
  var handleChange = function handleChange(value) {
    setShowTooltip(value && !showTooltip);
  };
  var classes = {
    tooltip: 'custom-tooltip',
    popper: 'custom-popper',
    arrow: 'custom-arrow'
  };
  var popperRef = (0, _react.useRef)();

  // (Only mobile) Ability to close on click away from the tooltip.
  (0, _react.useEffect)(function () {
    if (window.innerWidth <= 768) {
      var handleClick = function handleClick(e) {
        if (popperRef && popperRef.current) {
          var _e$target;
          if (!popperRef.current.contains(e.target) && ((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.alt) !== 'circled-question') {
            handleChange();
          }
        }
      };
      document.addEventListener('click', handleClick);
      return function () {
        return document.removeEventListener('click', handleClick);
      };
    }
  }, []);
  return title ? /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    onClick: handleChange,
    className: (0, _util.addClassNames)(className, BLOCK_CLASS),
    classes: classes,
    title: /*#__PURE__*/_react.default.createElement("div", {
      ref: popperRef
    }, /*#__PURE__*/_react.default.createElement(_base.default, {
      className: "wrapper"
    }, title, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      "aria-label": "Close",
      onClick: handleChange,
      onKeyDown: handleChange,
      className: "close"
    }))),
    open: showTooltip,
    placement: "bottom",
    interactive: true,
    arrow: true
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "circled-question",
    src: _questionIcon.default
  })) : /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _util.addClassNames)(className, BLOCK_CLASS)
  });
};
Tooltip.propTypes = {
  className: _propTypes.default.string,
  title: _propTypes.default.string
};
Tooltip.defaultProps = {
  className: '',
  title: ''
};
var _default = Tooltip;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');